import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";
import { ApiError } from "@nens/react-query-utils";

import { useInvalidateProfileImageQuery } from "../../../queries/query-profile-picture";

type ChangeProfileImageProps = {
  id: string;
  imageUpload: Blob;
};

export const useChangeProfileImage = () => {
  const invalidateProfileImageQuery = useInvalidateProfileImageQuery();
  return useMutationWithErrorHandler<void, ApiError, ChangeProfileImageProps>(
    async ({ id, imageUpload }: ChangeProfileImageProps) => {
      await getRanaApiV1().UsersApi.userChangeImage({
        id,
        imageUpload,
      });

      invalidateProfileImageQuery(id);
    },
    {}
  );
};
